import React from "react";
import { motion } from "framer-motion";
import { Building2, Landmark } from "lucide-react";

const AREAS = [
  {
    icon: Building2,
    eyebrow: "Área 1",
    title: "Empresas & Particulares",
    desc:
      "Soluções ajustadas ao consumo de cada empresa ou utilização doméstica, com aconselhamento orientado para reduzir o custo por impressão e evitar compras desnecessárias.",
    bullets: ["Análise do custo por impressão", "Soluções para diferentes volumes", "Compras simples e sem desperdício"],
    accent: "#00AEEF",
  },
  {
    icon: Landmark,
    eyebrow: "Área 2",
    title: "Setor Público & Concursos",
    desc:
      "Acompanhamento de consultas e procedimentos de contratação, com planeamento de necessidades e capacidade para organizar o fornecimento ao longo do período contratado.",
    bullets: ["Resposta a consultas e concursos", "Documentação organizada", "Entregas programadas"],
    accent: "#FF7F00",
  },
];

export default function Areas() {
  return (
    <section id="atuacao" className="relative py-24 lg:py-32 bg-[#0A1F44] text-white overflow-hidden" data-testid="areas-section">
      <div className="absolute inset-0 bg-grid-dark opacity-50 pointer-events-none" />
      <div className="absolute inset-x-0 top-0 h-[2px] cmyk-gradient" />

      <div className="relative w-full px-5 lg:px-8">
        <div className="max-w-3xl mb-16">
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#00AEEF] font-semibold mb-4">
            Áreas de Atuação
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05]" data-testid="areas-title">
            Trabalhamos em duas frentes.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {AREAS.map((a, i) => {
            const Icon = a.icon;
            return (
              <motion.div
                key={a.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="relative rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-sm p-8 lg:p-10 hover:bg-white/[0.06] transition-colors"
                data-testid={`area-card-${i}`}
              >
                <div className="flex items-start justify-between mb-8">
                  <div className="h-12 w-12 rounded-xl flex items-center justify-center" style={{ background: `${a.accent}22`, color: a.accent }}>
                    <Icon size={22} />
                  </div>
                  <span className="text-[10px] uppercase tracking-[0.22em] text-slate-400 font-semibold">{a.eyebrow}</span>
                </div>
                <h3 className="font-display text-3xl lg:text-4xl font-semibold tracking-tight mb-4">{a.title}</h3>
                <p className="text-slate-300 leading-relaxed mb-7">{a.desc}</p>
                <ul className="space-y-2.5">
                  {a.bullets.map((b) => (
                    <li key={b} className="flex items-center gap-3 text-sm text-slate-300">
                      <span className="h-1.5 w-1.5 rounded-full" style={{ background: a.accent }} />
                      {b}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>


      </div>
    </section>
  );
}
